import dayjs from "dayjs";

const MAX = dayjs("9999-12-31");

export const MAX_FUTURE_DATE = MAX.toDate();

export const MAX_FUTURE_DATE_ISO = MAX.format("YYYY-MM-DD");
